"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ApplyServiceConst = /** @class */ (function () {
    function ApplyServiceConst() {
    }
    Object.defineProperty(ApplyServiceConst, "KOBETSU", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplyServiceConst, "ORAL_CARE", {
        get: function () {
            return 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplyServiceConst, "BASIC", {
        get: function () {
            return 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplyServiceConst, "STANDARD", {
        get: function () {
            return 3;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplyServiceConst, "UPGRADE_TO_STANDARD", {
        get: function () {
            return 4;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplyServiceConst, "ADDITIONAL_TABLET", {
        get: function () {
            return 5;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplyServiceConst, "MOTION_AI", {
        get: function () {
            return 6;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplyServiceConst, "OLD_STANDARD", {
        // 2024/01/31〜2024/03/31まで限定
        get: function () {
            return 7;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplyServiceConst, "ENTRY", {
        get: function () {
            return 8;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplyServiceConst, "MEDIUM", {
        get: function () {
            return 9;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplyServiceConst, "PROFESSIONAL", {
        get: function () {
            return 10;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplyServiceConst, "UPGRADE", {
        get: function () {
            return 11;
        },
        enumerable: true,
        configurable: true
    });
    return ApplyServiceConst;
}());
exports.default = ApplyServiceConst;



//////////////////
// WEBPACK FOOTER
// ./common/src/constrains/contract_form/apply_service_const.ts
// module id = Vk7e
// module chunks = 1